<template>
  <div class="activity-time-status" :class="`is-${state.key}`" role="status">
    <strong class="time-status-title">{{state.text}}</strong>
    <div v-if="showPeriod && Number(timeLimit) === 1" class="time-status-period">
      有效期（北京时间）：{{formatActivityTime(startTime)}} 至 {{formatActivityTime(endTime)}}
    </div>
    <div class="time-status-hint">{{state.hint}}</div>
    <div v-if="showListing" class="time-status-hint">上架状态：{{Number(activityStatus) === 1 ? '上架' : '下架（下单不会触发本活动）'}}</div>
  </div>
</template>

<script>
import { activityTimeState, formatActivityTime } from './activityTime'
export default {
  props: {
    timeLimit: { default: null },
    startTime: { default: null },
    endTime: { default: null },
    now: { type: Number, required: true },
    activityStatus: { default: 0 },
    showListing: { type: Boolean, default: false },
    showPeriod: { type: Boolean, default: false }
  },
  computed: {
    state() {
      return activityTimeState(this.timeLimit, this.startTime, this.endTime, this.now)
    }
  },
  methods: { formatActivityTime }
}
</script>

<style lang="scss" scoped>
.activity-time-status {
  padding: 12px;
  border-radius: 4px;
  background: #f4f4f5;
  color: #606266;
  text-align: left;
  white-space: normal;
  overflow-wrap: anywhere;
  .time-status-title {
    display: block;
    font-size: 20px;
    line-height: 28px;
    font-variant-numeric: tabular-nums;
  }
  .time-status-hint, .time-status-period {
    font-size: 12px;
    line-height: 20px;
    margin-top: 4px;
  }
  &.is-active { background: #f0f9eb; color: #3d761f; }
  &.is-upcoming { background: #ecf5ff; color: #2464a5; }
  &.is-expired { background: #fef0f0; color: #bd3030; }
  &.is-invalid { background: #fdf6ec; color: #94621c; }
}
</style>
